<template>
  <div class="view--worker-info">
    <div class="grid-container">
      <!-- Datos Personales -->
      <div class="left-side">
        <mdtec-panel class="worker-panel full-height">
          <template v-slot:title>
            <div class="card-header">
              <v-icon large :color="$getColor('vuetifyColor1')" class="mr-2">mdi-account-details</v-icon>
              <h3>Datos Personales</h3>
            </div>
          </template>
          <template v-slot:content>
            <div class="worker-info">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    label="Nombre completo"
                    :value="fullName"
                    readonly
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-text-field
                    label="DNI / Documento"
                    :value="worker.idDocument"
                    readonly
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-text-field
                    label="Email"
                    :value="worker.email"
                    readonly
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" v-if="worker.phone">
                  <v-text-field
                    label="Teléfono"
                    :value="worker.phone"
                    readonly
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </template>
        </mdtec-panel>
      </div>

      <!-- Códigos N2 -->
      <div class="right-side">
        <mdtec-panel class="full-height">
          <template v-slot:title>
            <div class="card-header">
              <v-icon large :color="$getColor('vuetifyColor1')" class="mr-2">mdi-format-list-numbered</v-icon>
              <h3>Códigos N2 (Conceptos Salariales)</h3>
            </div>
          </template>
          <template v-slot:content>
            <div class="n2-table-wrapper">
              <v-simple-table dense fixed-header height="400px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Nombre</th>
                      <th class="text-left">Código</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in worker.n2Codes" :key="item.id">
                      <td>{{ item.name }}</td>
                      <td>
                        <v-chip x-small label outlined :color="$getColor('vuetifyColor1')">
                          {{ item.code }}
                        </v-chip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </template>
        </mdtec-panel>
      </div>
    </div>
  </div>
</template>

<script>
import MdtecPanel from '@/components/Cards/MdtecPanel.vue';

export default {
  name: 'WorkerInfo',
  components: {
    MdtecPanel,
  },
  props: {
    worker: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    fullName() {
      if (!this.worker) return '';
      const name = this.worker.name || '';
      const lastName1 = this.worker.lastName1 || '';
      const lastName2 = this.worker.lastName2 || '';
      return `${name} ${lastName1} ${lastName2}`.trim();
    },
  },
};
</script>

<style scoped lang="scss">
.view--worker-info {
  height: 100%;
  padding-top: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .grid-container {
    display: grid;
    gap: calc(var(--base) * 2);
    grid-template-columns: repeat(12, 1fr);
    height: 100%;

    .left-side {
      grid-column: 1 / span 5;
    }
    @media (max-width: 960px) {
      .left-side {
        grid-column: 1 / span 12;
      }
    }

    .right-side {
      grid-column: 6 / span 7;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
    @media (max-width: 960px) {
      .right-side {
        grid-column: 1 / span 12;
      }
    }

    .full-height {
      height: 100%;
    }
  }
}

.worker-info {
  padding-top: calc(var(--base) * 2);
}

.card-header {
  display: flex;
  align-items: center;

  h3 {
    font-size: 1.15rem; // Adjust h3 font size to align with MdtecPanel headers
    font-weight: 500;
    margin: 0;
  }
}

.n2-table-wrapper {
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);

  .v-data-table {
    background: transparent !important;
  }
}
</style>
<style lang="scss">
.view--worker-info {
  & .mdtec-card.worker-panel {
    height: 100%;
  }
  & .mdtec-card.full-height {
    height: 100%;
  }
}
</style>
